function ScrollLine(m,e, t) {

    console.log('t= ', t);
    var o = n("undefined" != typeof window ? window.jQuery : void 0 !== e ? e.jQuery : null);

    function n(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }
    var r, s, i = (0,
            o.default)(".story-list"),
        a = (0,
            o.default)(".story-list__item", i),
        l = window.pageYOffset,
        u = window.innerHeight,
        c = !1,
        d = !1,
        h = 0;

    function f() {
        if (1 == d)
            return !1;
        d = !0,
            l = window.pageYOffset,
            u = window.innerHeight,
            s = Math.max(h, l + .5 * u - r),
            (0,
                o.default)(".story-list__progress").css("height", s + "px"),
            d = !1
    }

    function p() {
        r = (0,
                o.default)(".story-list__progress").offset().top,
            a.each(function(e, t) {
                var n = (0,
                    o.default)(t);
                n.data("position-top", n.find(".story-list__item-header").offset().top + 23.5 - r),
                    0 == e && (h = n.data("position-top"))
            })
    }

    function g() {
        if (1 == c)
            return !1;
        c = !0,
            a.each(function(e, t) {
                var n = (0,
                        o.default)(t),
                    i = n.data("position-top");
                i || (i = n.find(".story-list__item-header").offset().top + 23.5 - r,
                        n.data("position-top", i)),
                    i <= s ? n.addClass("story-list__item--visible") : n.removeClass("story-list__item--visible")
            }),
            c = !1
    }

    0 < i.length && (i.prepend('<div class="story-list__progress" aria-hidden="true"></div>'),
        p(),
        f(),
        g(),
        t.default.$window.on("resize", function() {
            p()
        }),
        t.default.$window.on("scroll resize", function() {
            f(),
                g()
        }))
    .call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {})
}

function isInView($el){
var wTop = $(window).scrollTop();
var wBot = wTop + $(window).height();
var eTop = $el.offset().top ;
var eBot = eTop + $el.height() ;

var r = 80;
var l = window.pageYOffset;
var m = $('.story-list').offset().top;
var u =  window.innerHeight;
var h =  Math.max(r, l - m + .5 * u) ;

$(".story-list__progress").css("height", h + "px");

var n = $el.find('.story-list__item-content').offset().top;
var t = window.pageYOffset   + .5 * u

//if (n <= t) console.log('h= ' + h + ' l =' + l + ' u =' + u  + ' n =' + n + ' t = ' + t );

return ((n <= t) );
}

function setInView(){
$(".story-list li.story-list__item").each(function(){
var $ele = $(this);
$ele.removeClass("story-list__item--visible");
if(isInView($ele)){
  var classList = $($ele).attr('class').split(/\s+/);
    //$.each(classList, function(index, item) { console.log('class = ' + item); });
      $ele.addClass("story-list__item--visible");
}
});
}

$(document).scroll(function(){
setInView();
});
$(document).resize(function(){
setInView();
});
$(document).ready(function(){
setInView();
});
